import { Base64 } from 'js-base64';
import * as type from './type-utils';

/**
 * 对象转换成 json string
 * @param input
 * @return {*}
 */
function object2JSONString(input) {
  if (!type.isNullOrUndefined(input)) {
    let str = input;
    if (type.isObjectLike(str)) {
      str = JSON.stringify(str);
    }
    if (type.isString(str)) {
      return JSON.stringify(str);
    }
  }
  throw new Error('the type of input should be {object} or {string}');
}

/**
 * 判断是否是 base64 图片字符串,
 * e.g.
 * 输入: data:image/png;base64,iVBORw0KGgoA
 * 输出: true
 * @param {string} base64ImageString - base64 图片字符串
 * @return {boolean}
 */
export function isBase64ImageString(base64ImageString) {
  return /^data:image\/([a-zA-Z]*);base64,([^"]*)/.test(base64ImageString);
}


/**
 * base 64 url 编码
 * @param input
 */
export function base64UrlEncode(input) {
  const str = object2JSONString(input);
  return Base64.toBase64(str, true);
}

/**
 * base 64 url 解码
 * @param str
 * @param jsonParse
 * @return {*}
 */
export function base64UrlDecode(str, jsonParse = true) {
  const result = Base64.fromBase64(str);
  if (jsonParse) {
    return JSON.parse(result);
  }
  return result;
}

/**
 * 剔除指定 props
 * 来源: babel-runtime/helpers/objectWithoutProperties
 * 用法: withoutProps(this.props, ['status'])
 * @param obj
 * @param keys
 */
export function withoutProps(obj, keys) {
  const target = {};

  for (let i in obj) {
    // noinspection JSUnfilteredForInLoop
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
